const Roles = {
  User: 0,
  Admin: 1
};

export default Roles;
